// Module
var code = "<cr-row-builder-legacy type=\"cr-hours-builder-row\" on-change=\"$ctrl.onRowBuilderChange(state)\" rows=\"$ctrl.rows\" label=\"{{ ::$ctrl.text.label }}\" add-text=\"{{ ::$ctrl.text.addText }}\"></cr-row-builder-legacy> ";
// Exports
export default code;